module.exports = __webpack_public_path__ + "media/hallelujah.09e041b9.mp3";